<template>
      <form method="post" id="form-register-email" @submit.prevent="save">
        <div class="panel-body" style="border-top: none; border-radius: 3px !important;">
          <h4 class="text-center mb-5">Try for free</h4>
          <p class="text-center mb-30">No credit card needed</p>
          <div class="alert alert-danger" v-if="errors.length > 0">
            <ul>
              <li v-for="(error, index) in errors" class="text-left" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div class="alert alert-success" style="display: none"></div>
          <div class="form-horizontal mb-0">
            <input type="hidden" name="do" value="try" />
            <div class="row mb-20">
              <div class="col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon icon="envelope" />
                  </span>
                  <input name="email" type="text" class="form-control" id="email" placeholder="E-mail" required v-model="email">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="">
            <button type="button" id="get_access" class="btn btn-primary w-100" @click="save">
              <span v-if="!isLoading">Next</span>
              <pulse-loader :loading="isLoading" color="white" size="5px" />
            </button>
          </div>
        </div>
      </form>
</template>

<script>
// @ is an alias to /src

import {mapGetters} from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader";

export default {
  name: 'Home',
  data() {
    return {
      isLoading: false,
      errors: []
    }
  },
  created() {
  },
  components: {
    PulseLoader
  },
  computed: {
    ...mapGetters({
      getEmail: 'getEmail'
    }),
    email: {
      get() {
        return this.getEmail
      },
      set(val) {
        this.$store.commit('SET_EMAIL', val)
      }
    }
  },
  methods: {
    save() {
      if(!this.validate()) return false;

      this.isLoading = true;
      this.$store.dispatch('submit', {email: this.email})
              .then(() => {
                this.isLoading = false;
                this.$router.push({name: 'more-info'});
              })
    },
    checkEmail(value) {
      return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(value);
    },
    validate() {
      this.errors = [];
      if(!this.checkEmail(this.email)) {
        this.errors.push('Invalid email.')
      }

      return this.errors.length === 0
    }
  }
}
</script>

<style scoped lang="less">
</style>